import { ButtonGroup, Icon, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 40px;
  padding: 0 20px;
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  gap: 8px;
  ${typographyV2.titleXL};
  margin-bottom: 12px;
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  width: fit-content;
  white-space: nowrap;
`;

export const AlfredIcon = styled(Icon)`
  fill: var(--icon-primary);
`;

export const Description = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;
